import { Page, PageHeader } from "@dash/page";

import { useClientManager } from "@megaron/react-clients";

import { SyncBar } from "./SyncBar";
import { SyncResultView } from "./SyncResultsView";

export const ExportShopifyVariantsPage = () => {
  const query = useClientManager("catalog").exportShopifyProductVariants().useQuery({
    dryRun: true,
  });

  const commitMutation = useClientManager("catalog").exportShopifyProductVariants().useMutation();

  const commit = async () => {
    await commitMutation.mutateAsync({
      dryRun: false,
    });
  };

  return (
    <Page css={{ maxWidth: "100%", gap: "1rem", display: "flex", flexDirection: "column" }}>
      <PageHeader>Eksportuj warianty produktów Shopify</PageHeader>
      <SyncBar onCommit={commit} isLoading={query.isLoading || commitMutation.isLoading} />

      <SyncResultView
        isLoading={query.isLoading}
        result={query.data}
        labels={{
          productId: "ID produktu",
          variantId: "ID wariantu",
          variantTitle: "Tytuł wariantu",
          sku: "SKU",
          weightKg: "Waga",
          barcode: "Kod kreskowy",
        }}
      />
    </Page>
  );
};
